"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var interpolate = function interpolate(name, sel) {
  return "".concat(sel, " ").concat(name);
};

var _default = function _default(name, props) {
  if (typeof props === 'string') return interpolate(name, props);
  if (props && props['data-qa']) return interpolate(name, props['data-qa']);
  return name;
};

exports.default = _default;